export default "Industrie & sites de production — Audit NF EN 16247, CEE IND, ISO 50001 | Solution Éco France";
